import * as z from "zod/v4";

const ProfileDateRangeSchema_ = z.object({
  startDate: z.string(),
  endDate: z.string(),
});
export const ProfileDateRangeSchema: z.ZodType<ProfileDateRange> =
  ProfileDateRangeSchema_;
export interface ProfileDateRange
  extends z.infer<typeof ProfileDateRangeSchema_> {}
